import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { CanComponentDeactivate } from '@app/core/auth/can-component-deactivate.interface';
import { RetailStoreFormWrapperComponent } from '../components/retail-store-form-wrapper/retail-store-form-wrapper.component';
import { 
  RetailStoreFormConfig,
  RETAIL_STORE_FORM_CONFIG
} from '../retail-store.config';

@Component({
  selector: 'app-retail-store-add',
  standalone: true,
  imports: [RetailStoreFormWrapperComponent],
  templateUrl: './retail-store-add.component.html',
  styleUrls: ['./retail-store-add.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RetailStoreAddComponent implements CanComponentDeactivate {
  @ViewChild('formWrapper') private readonly formWrapper?: RetailStoreFormWrapperComponent;

  config: RetailStoreFormConfig = {
    title: 'retailStore.form.add_physical_store',
    formFields: RETAIL_STORE_FORM_CONFIG.formFields,
    headerActions: RETAIL_STORE_FORM_CONFIG.headerActions,
    sectionButtons: RETAIL_STORE_FORM_CONFIG.sectionButtons,
    listRoute: '/channel/retail-store'
  };

  canDeactivate(): boolean {
    return this.formWrapper?.canDeactivate() ?? true;
  }
}
